var store = window.localStorage;

export function setItem(key,val) {
  store.setItem(key, val);
}

export function deleteKey(key) {
  store.removeItem(key);
}

export function getItem(key) {
  return store.getItem(key);
}

// 移除全部永久缓存
export function clearLocal() {
  store.clear();
}

// 2. sessionStorage
// 设置临时缓存
export function setSession(key, val) {
  window.sessionStorage.setItem(key, JSON.stringify(val));
}
// 获取临时缓存
export function getSession(key) {
  let json = window.sessionStorage.getItem(key);
  return JSON.parse(json);
}
// 移除临时缓存
export function removeSession(key) {
  window.sessionStorage.removeItem(key);
}
// 移除全部临时缓存
export function clearSession() {
  window.sessionStorage.clear();
}
